<template>
  <el-dialog style="margin-top: 20vh;" :before-close="closeDialog" width="400px" :visible.sync="dateDialog" :title="title">
    <div class="dialog_box">
      <div class="time">
        <el-date-picker class="dialog_date" v-model="date" v-on:change="datePickerChange" type="daterange" :start-placeholder="$t('enum.beginDate')" :end-placeholder="$t('enum.endDate')" :picker-options="fType == 1 ? pickeroptions1 : pickeroptions2" :default-value="timeDefaultShow">
        </el-date-picker>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="operate_r" style="text-align: right;">
        <el-button @click="closeDialog">{{ $t('button.cancel') }}</el-button>
        <el-button class="apply" type="primary" @click="dateConfirm">{{ $t('button.done') }}</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dashboard',
  components: {},
  computed: {  },
  props: {
    dateDialog: Boolean,
    beginDate: String,
    endDate: String,
    fType: Number
  },
  data() {
    return {
      userInfo:this.$store.state.UserInfo,
      title: this.$t("enum.selectDate"),
      maxStateDate: '2020-01-01',
      date: [],//默认时间范围
      timeDefaultShow: new Date().setMonth(new Date().getMonth() - 1),
      startTime: "",
      endTime: "",
      pickeroptions1: {},
      pickeroptions2: {},
    }
  },
  watch: {
    fType:{
      handler(val) {
        // console.log('watch-fType', val);
      }
    },
    maxStateDate: {
      handler(val) {
        console.log('watch-maxStateDate', val);
        var __maxStateDate = val;
        /** pickeroptions1 **/
        this.pickeroptions1 = {
          /*6个月内 的时间选择*/
          // onPick：是选中日期时的回调函数，可以在这里对选中的日期进行处{maxDate：后选中日期；minDate：第一个选中的日期}
          onPick: ({ maxDate, minDate }) => {
            var that = this
            that.startDate = minDate && minDate.getTime();
            if (maxDate) {
              // 选中后一个时，要把第一个的赋值清空
              that.startDate = ''
            }
          },
          disabledDate: (time) => {
            var that = this
            const today = (new Date()).getTime();//今天
            // console.log("this.startDate", typeof (that.startDate))
            let xxx = that.startDate ? (today - that.startDate) / (24 * 60 * 60 * 1000) : 0;//起始时间距当天日期间隔天数
            xxx = xxx >= 0 ? Math.abs(xxx) : 0;
            // console.log("today", parseInt(today), "this.startDate", this.startDate, "xxx", xxx);
            const month = 30 * 24 * 60 * 60 * 1000 // 设定日期范围
            const minTime = that.startDate - month
            const maxTime = xxx >= 0 && xxx < 30 ? that.startDate + xxx * 24 * 60 * 60 * 1000 : that.startDate + month;
            const _maxStartDate = new Date(__maxStateDate);//最大起始日期，当前日期前6个月

            if (that.startDate) {
              // 选中第一个时，前后30天[-30,30]共60天可选选择，超出的不可选，这里的天数按自己喜欢设定
              //time.getTime() < minTime || time.getTime() > maxTime || 
              return time.getTime() >= today || time.getTime() <= _maxStartDate;
            }
            else {
              // 不选任何日期执行下面的代码
              return time.getTime() >= today || time.getTime() <= _maxStartDate;//time.getTime() > Date.now();//Date.now() - 8.64e6;
            }
          }
        };
        /** pickeroptions2 **/
        this.pickeroptions2 = {
          /*6个月以前 的时间选择*/
          // onPick：是选中日期时的回调函数，可以在这里对选中的日期进行处{maxDate：后选中日期；minDate：第一个选中的日期}
          onPick: ({ maxDate, minDate }) => {
            var that = this
            that.startDate = minDate && minDate.getTime();
            if (maxDate) {
              // 选中后一个时，要把第一个的赋值清空
              that.startDate = ''
            }
          },
          disabledDate: (time) => {
            var that = this
            const today = (new Date()).getTime();//今天
            let xxx = that.startDate ? (today - that.startDate) / (24 * 60 * 60 * 1000) : 0;//起始时间距当天日期间隔天数
            xxx = xxx >= 0 ? Math.abs(xxx) : 0;
            // console.log("today", parseInt(today), "this.startDate", this.startDate, "xxx", xxx);
            const month = 365 * 24 * 60 * 60 * 1000 // 设定日期范围
            const minTime = that.startDate - month
            const maxTime = xxx >= 0 && xxx < 365 ? that.startDate + xxx * 24 * 60 * 60 * 1000 : that.startDate + month;
            const _maxStartDate = new Date(__maxStateDate);//最大起始日期，当前日期前6个月

            if (that.startDate) {
              // 选中第一个时，前后365天[-365,365]共365天可选选择，超出的不可选，这里的天数按自己喜欢设定
              //time.getTime() < minTime || time.getTime() > maxTime || 
              return time.getTime() >= _maxStartDate || time.getTime() < minTime || time.getTime() > maxTime;
            }
            else {
              return time.getTime() >= _maxStartDate
            }
          }
        }
      },
      deep: true
    },
  },
  created() { },
  methods: {
    // 调用父级关闭弹框事件
    closeDialog(type) {
      this.$emit('closeDialog', type)
    },
    /*日期*/
    dateConfirm() {
      var that = this;
      let _date = that.date;
      if (_date && _date.length) {
        let beginDate = that.$store.getters.getDateTime("yyyy-MM-dd", _date[0]);
        let endDate = that.$store.getters.getDateTime("yyyy-MM-dd", _date[1]);
        // console.log("dateConfirm", beginDate, endDate);
        // that.getData('WalletRecordByPage');
        this.$emit('closeDialog', { type: 'getList', beginDate, endDate })
      } else { }
    },
    datePickerChange(e) {
      var that = this;
      let _date = that.date;
      if (_date && _date.length) {
        let beginDate = _date[0];
        let endDate = _date[1];
      } else { }
    },
  }
}
</script>

<style scoped>
.title {
  width: 100px;
  font-weight: bold;
  padding-right: 12px;
  text-align: right;
}

.wallet_row {
  display: flex;
  padding-bottom: 20px;
}

.el-dialog__wrapper>>>.el-dialog__header {
  padding: 20px;
}

.el-dialog__wrapper>>>.el-dialog__body {
  padding: 0;
}

span {
  color: #409eff;
}

.dialog_box {
  border-top: 1px solid #eee;
  padding: 20px;
}

.dialog_box:first-child {
  padding-bottom: 20px;
}

.operate_c .apply {
  background: #004ecb;
  background-image: linear-gradient(to bottom right, #0279cb, #004ecb);
}

.operate_c .apply:hover {
  background: #66b1ff;
}

.operate_r .apply {
  background: #66b1ff;
  border-color: #66b1ff;
}

.operate_c .is-disabled {
  background: #66b1ff;
  border-color: #66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/wallet-date-picker.vue